<template>
  <popup-dialog @close="close" :z-index="2000" v-if="visible">
    <div class="login-english">
      <div class="login-english-logo">
        <img src="~@/assets/english_logo.png" alt="CF40 RESEARCH" />
      </div>
      <div class="login-english-form">
        <el-form ref="subForm" :model="subForm" :rules="rules" label-width="150px">
          <el-form-item label="Account" prop="username" v-if="type == 'login'">
            <el-input v-model="subForm.username" placeholder="Please enter your account" @keyup.native.enter="operate" clearable></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email" v-if="type == 'register' || type == 'forgot'">
            <el-input v-model="subForm.email" placeholder="Please enter your email" @keyup.native.enter="operate" clearable></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input v-model="subForm.password" type="password" placeholder="Please enter your password" @keyup.native.enter="operate" clearable></el-input>
          </el-form-item>
          <el-form-item label="Confirm Password" prop="checkPass" v-if="type == 'register' || type == 'forgot'">
            <el-input v-model="subForm.checkPass" type="password" placeholder="Please enter your password again" @keyup.native.enter="operate" clearable></el-input>
          </el-form-item>
          <el-form-item label="Code" prop="code" v-if="type == 'register' || type == 'forgot'">
            <div class="code-row">
              <el-input v-model="subForm.code" placeholder="Please enter your code" @keyup.native.enter="operate" clearable></el-input>
              <el-button class="get-code" :loading="codeLoading" :disabled="countdown > 0" @click="getVeriCode">
                {{ countdown > 0 ? `${countdown} Seconds Again` : 'Get Code' }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item v-if="type == 'login' || type == 'register'">
            <login-consent v-model="agreementsAccepted" english @open="openProtocol" />
          </el-form-item>
          <el-form-item>
            <el-button class="submit" :loading="loading" @click="operate">
              <span v-if="type == 'login'">Sign In</span>
              <span v-else-if="type == 'register'">Register</span>
              <span v-else-if="type == 'forgot'">Reset Password</span>
            </el-button>
          </el-form-item>
          <template v-if="type == 'login'">
            <el-form-item>
              <div class="flex-row">
                <div class="forgot-pass" @click="typeChange('forgot')">
                  Forgot your password?
                </div>
                <div class="register" @click="typeChange('register')">
                  Register
                </div>
              </div>
            </el-form-item>
          </template>
          <template v-else-if="type == 'register'">
            <el-form-item>
              <div class="flex-row">
                <div class="forgot-pass" @click="typeChange('forgot')">
                  Already have an account?
                </div>
                <div class="register" @click="typeChange('login')">
                  Sign In
                </div>
              </div>
            </el-form-item>
          </template>
          <template v-else-if="type == 'forgot'">
            <el-form-item>
              <div class="flex-row">
                <div class="forgot-pass"></div>
                <div class="register" @click="typeChange('login')">
                  Sign In
                </div>
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </div>
    <service-agreement ref="serviceAgreementRef"></service-agreement>
  </popup-dialog>
</template>

<script>
import PopupDialog from "../popupDialog";
import ServiceAgreement from "@/components/serviceAgreement";
import LoginConsent from "@/components/loginConsent";
import { loginSystem, registerSystem, sendRegisterCode, forgotPassword, sendForgotCode, initConfig } from "@/api";
import { showInitialPasswordNotice } from "@/utils/initialPasswordNotice";
export default {
  name: "LoginEnglish",
  components: {
    PopupDialog,
    ServiceAgreement,
    LoginConsent
  },
  data() {
    return {
      visible: false,
      agreementsAccepted: false,
      loading: false,
      codeLoading: false,
      protocolLoading: false,
      type: "login",
      subForm: {},
      countdown: 0,
      codeTimer: null,
      rules: {
        username: [
          { required: true, message: "Please enter your account", trigger: "blur" },
        ],
        email: [
          { required: true, message: "Please enter your email", trigger: "blur" },
          { type: "email", message: "Please enter the correct email format", trigger: ["blur", "change"] }
        ],
        password: [
          { required: true, message: "Please enter your password", trigger: "blur" },
          { min: 6, max: 16, message: "The length of the password is between 6 and 16 bits", trigger: "blur" },
        ],
        checkPass: [
          { validator: this.validatePassword, trigger: 'blur' }
        ],
        code: [
          { required: true, message: "Please enter the verification code", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 打开窗口
    open() {
      this.type = "login";
      this.agreementsAccepted = false;
      this.subForm = {
        username: "",
        email: "",
        password: "",
        checkPass: "",
        code: "",
        token: ""
      };
      this.visible = true;
    },
    // 关闭窗口
    close () {
      this.visible = false;
    },
    typeChange(e) {
      this.type = e;
      this.agreementsAccepted = false;
      this.subForm = {
        username: "",
        email: "",
        password: "",
        checkPass: "",
        code: "",
        token: ""
      };
      this.countdown = 0;
      this.codeTimer = null;
    },
    validatePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter your password again'));
      } else if (value !== this.subForm.password) {
        callback(new Error('The password entered twice is inconsistent!'));
      } else {
        callback();
      }
    },
    async loginHandle() {
      if (this.loading) return;
      if (!this.agreementsAccepted) {
        this.$message.warning('Please agree to the Membership Service Agreement and Privacy Policy.');
        return;
      }
      this.loading = true;
      try {
        const param = {
          username: this.subForm.username.replace(/\s/g, ''),
          password: this.subForm.password,
        };
        const res = await loginSystem(param, true);
        if (res && res.code == 200 && res.data && res.data.token) {
          localStorage.setItem("cf40-token", res.data.token);
          this.close();
          this.$message.success("Login successful");
          await showInitialPasswordNotice(this, res.data, true);
          this.$emit("success");
        }
      } catch (error) {
        // 请求层统一显示登录和网络错误。
      } finally {
        this.loading = false;
      }
    },
    async registerHandle() {
      if (this.loading) return;
      if (!this.agreementsAccepted) {
        this.$message.warning('Please agree to the Membership Service Agreement and Privacy Policy.');
        return;
      }
      this.loading = true;
      let param = {
        email: this.subForm.email,
        password: this.subForm.password,
        code: this.subForm.code,
      };
      let res = await registerSystem(param, true);
      if (res && res.code == 200) {
        if (res.data && res.data.token) {
          localStorage.setItem("cf40-token", res.data.token);
          this.$emit("success");
          this.close();
          this.$message.success("successful");
        }
      }
      this.loading = false;
    },
    async forgotHandle() {
      this.loading = true;
      let param = {
        password: this.subForm.password,
        code: this.subForm.code,
        token: this.subForm.token
      };
      let res = await forgotPassword(param, true);
      if (res && res.code == 200) {
        this.typeChange("login")
        this.$message.success(res.msg ? res.msg : "Reset password successful");
      }
      this.loading = false;
    },
    async registerCode() {
      this.codeLoading = true;
      let param = {
        email: this.subForm.email
      };
      let _This = this;
      if (!_This.codeTimer) {
        let res = await sendRegisterCode(param, true);
        if (res && res.code == 200) {
          this.$message.success(res.msg ? res.msg : 'verification code sent successfully');
          _This.countdown = 60;
          _This.codeTimer = setInterval(() => {
            _This.countdown--;
            if (_This.countdown <= 0) {
              clearInterval(_This.codeTimer);
              _This.codeTimer = null;
            }
          }, 1000);
        }
      }
      this.codeLoading = false;
    },
    async forgotCode() {
      this.codeLoading = true;
      let param = {
        email: this.subForm.email
      };
      let _This = this;
      if (!_This.codeTimer) {
        let res = await sendForgotCode(param, true);
        if (res && res.code == 200) {
          if (res.data && res.data.token) {
            this.subForm.token = res.data.token;
            this.$message.success(res.msg ? res.msg : 'verification code sent successfully');
            _This.countdown = 60;
            _This.codeTimer = setInterval(() => {
              _This.countdown--;
              if (_This.countdown <= 0) {
                clearInterval(_This.codeTimer);
                _This.codeTimer = null;
              }
            }, 1000);
          }
        }
      }
      this.codeLoading = false;
    },
    async openProtocol(name, key) {
      if (this.protocolLoading) return;
      this.protocolLoading = true;
      try {
        const res = await initConfig();
        const agreement = res && res.code == 200 && Array.isArray(res.data)
          ? res.data.find(item => item.config_key == key)
          : null;
        if (agreement && agreement.config_value && agreement.config_value.trim() && this.$refs.serviceAgreementRef) {
          this.$refs.serviceAgreementRef.open(name, agreement.config_value);
        } else if (this.visible) {
          this.$message.warning('Unable to load the agreement. Please try again later.');
        }
      } catch (error) {
        if (this.visible) this.$message.warning('Unable to load the agreement. Please try again later.');
      } finally {
        this.protocolLoading = false;
      }
    },
    getVeriCode() {
      this.$refs.subForm.validateField('email', (valid) => {
        if (!valid) {
          if (this.type == "register") {
            this.registerCode();
          } else if (this.type == "forgot") {
            this.forgotCode();
          }
        }
      });
    },
    operate() {
      this.$refs.subForm.validate((valid) => {
        if (valid) {
          if (this.type == 'login') {
            this.loginHandle();
          } else if (this.type == 'register') {
            this.registerHandle();
          } else if (this.type == 'forgot') {
            this.forgotHandle();
          }
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.login-english {
  .code-row {
    display: flex;
    gap: 8px;
    align-items: center;
    .el-input {
      flex: 1;
      min-width: 0;
    }
    .get-code {
      flex: none;
      margin: 0;
      padding: 12px 10px;
      font-size: 14px;
      white-space: nowrap;
      color: #ffffff;
      border-color: #ed6f33;
      background-color: #ed6f33;
      &:hover, &:focus, &.is-disabled {
        color: #ffffff;
        border-color: #fa996b;
        background-color: #fa996b;
      }
    }
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-logo {
    max-width: 280px;
    margin-left: 50px;
    margin-right: 20px;
  }
  &-form {
    flex: 1;
    min-width: 0;
    margin-right: 30px;
    margin-top: 30px;
    margin-bottom: 50px;
    .submit {
      width: 100%;
      padding: 10px 30px;
      font-size: 16px;
      font-family: Georgia_Bold;
      color: #ffffff;
      background-color: #ed6f33;
      &:hover {
        color: #ffffff;
        border-color: #fa996b;
        background-color: #fa996b;
      }
      &:active {
        border-color: #ed6f33;
        background-color: #ed6f33;
      }
    }
    .flex-row {
      display: flex;
      justify-content: space-between;
    }
    ::v-deep {
      .el-input__inner {
        &:focus {
          border-color: #ed6f33;
        }
      }
    }
    .tip-accord {
      font-size: 12px;
      line-height: 18px;
      .text-link {
        cursor: pointer;
        color: #ed6f33;
      }
    }
    .forgot-pass, .register {
      cursor: pointer;
      user-select: none;
      font-family: Georgia_Bold;
      &:hover {
        color: #ed6f33;
      }
      &.no-link {
        cursor: auto;
        &:hover {
          color: inherit;
        }
      }
    }
    .verification-code {
      margin-left: 80px;
      &-header {
        &-title {
          cursor: pointer;
          padding: 20px;
          user-select: none;
          display: flex;
          &:hover {
            color: #ed6f33;
          }
        }
        &-tip {
          padding: 0 20px 20px;
        }
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .login-english {
    &-logo {
      max-width: 200px;
      margin-left: 20px;
      margin-right: 10px;
    }
    &-form {
      margin-right: 20px;
      margin-top: 20px;
      margin-bottom: 30px;
      .forgot-pass, .register {
        font-size: 12px;
      }
      .verification-code {
        margin-left: 30px;
        &-header {
          &-tip {
            padding: 0 0 20px 20px;
          }
        }
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .login-english {
    flex-direction: column;
    &-logo {
      max-width: 230px;
      margin: 15px 0 0 0;
    }
    &-form {
      width: 100%;
      margin-right: 0;
      .verification-code {
        margin-left: 0;
        &-header {
          &-title {
            padding-left: 0;
          }
          &-tip {
            padding: 0;
            line-height: 25px;
          }
        }
      }
      ::v-deep {
        .el-form-item__label {
          float: none;
        }
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .login-english .code-row {
    flex-wrap: wrap;
    .el-input {
      flex-basis: 100%;
    }
  }
}
</style>
